import { NavItems } from "@helpers/navigation";
import { REMOTE_ASSESSMENT_LINK_TOKEN_KEY, type StorageAssessmentForm } from "../pages/assessmentWelcome";

export const isRemoteAssessmentComplete = (pathname: string): boolean => {
    const storageAssessmentForm = JSON.parse(
        localStorage.getItem("assessmentForm") ?? "{}"
    ) as Partial<StorageAssessmentForm>;

    if (
        storageAssessmentForm.isRemote !== true ||
        storageAssessmentForm.isCompleted !== true ||
        pathname === NavItems.Assessments.AssessmentComplete.path
    ) {
        return false;
    }

    if (pathname.startsWith(NavItems.Assessments.RemoteLanding.path)) {
        return false;
    }

    if (!storageAssessmentForm.assessmentId || !storageAssessmentForm.remoteAssessmentToken) {
        return false;
    }

    const activeRemoteAssessmentToken = sessionStorage.getItem(REMOTE_ASSESSMENT_LINK_TOKEN_KEY);

    if (!activeRemoteAssessmentToken || activeRemoteAssessmentToken !== storageAssessmentForm.remoteAssessmentToken) {
        return false;
    }

    return true;
};
